import { ValidationIcon_default } from "./chunk-OKKCDA6J.js";
import { InputComponent } from "./chunk-OADWJROU.js";
import { Spinner_default } from "./chunk-KRDKEFRG.js";
import { renderIcon } from "./chunk-M6GKR2SP.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/TextInput/TextInput.tsx
import React, { forwardRef, useMemo, useRef, useImperativeHandle } from "react";
import clsx from "clsx";
var TEXT_INPUT_CLASSNAME_MAP = {};
var TextInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      variant = "secondary",
      suffix,
      iconBefore: iconBeforeProp,
      iconAfter: iconAfterProp,
      disabled,
      validation,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["variant", "suffix", "iconBefore", "iconAfter", "disabled", "validation", "isLoading", "className"]);
  const inputRef = useRef(null);
  const iconBefore = useMemo(() => iconBeforeProp && renderIcon(iconBeforeProp), [iconBeforeProp]);
  const iconAfter = useMemo(() => iconAfterProp && renderIcon(iconAfterProp), [iconAfterProp]);
  useImperativeHandle(ref, () => inputRef.current);
  const handleSuffixClick = () => {
    var _a2;
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  return /* @__PURE__ */React.createElement(InputComponent, {
    variant,
    validation: variant === "secondary" ? validation : void 0,
    disabled,
    className: clsx("pd-text-input", className)
  }, iconBefore && /* @__PURE__ */React.createElement(InputComponent.Icon, null, iconBefore), /* @__PURE__ */React.createElement(InputComponent.Input, __spreadValues({
    ref: inputRef,
    isLoading
  }, rest)), suffix && /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
  /* @__PURE__ */React.createElement("span", {
    className: "pd-shrink-0 pd-text-dim-600",
    onClick: handleSuffixClick
  }, suffix), iconAfter && /* @__PURE__ */React.createElement(InputComponent.Icon, null, iconAfter), variant === "secondary" && validation && !isLoading && /* @__PURE__ */React.createElement(InputComponent.Icon, null, /* @__PURE__ */React.createElement(ValidationIcon_default, {
    variant: validation
  })), isLoading && /* @__PURE__ */React.createElement(InputComponent.Icon, null, /* @__PURE__ */React.createElement(Spinner_default, {
    variant: "primary"
  })));
});
var TextInput_default = TextInput;
export { TEXT_INPUT_CLASSNAME_MAP, TextInput_default };